import React, { Component, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/solid'
import { DuplicateIcon } from '@heroicons/react/solid'
import { CheckIcon } from '@heroicons/react/solid'
import { ShareIcon } from '@heroicons/react/solid'
import QRCode from 'qrcode'

class ShareApp extends Component {
	constructor(props) {
		super(props)
		this.state = {
			link: null,
			qr: null,
			copied: false,
			error: false,
			loading: false
		}
		this.copyTimer = null
	}

	componentDidMount() {
		if (this.props.open === true)
			this._load()
	}

	componentDidUpdate(prevProps) {
		if (this.props.open === true && prevProps.open === false)
			this._load()
	}

	componentWillUnmount() {
		if (this.copyTimer !== null)
			clearTimeout(this.copyTimer)
	}

	_getBaseUrl = () => {
		let base = (this.props.app_url) ? this.props.app_url : window.location.origin
		base = base.replace(/\/$/, '')
		return base
	}

	_load = () => {
		if (this.state.link !== null || this.state.loading === true)
			return ;
		if (!this.props.user || !this.props.user.client_number)
		{
			this.setState({ error: true })
			return ;
		}
		this.setState({ loading: true, error: false })
		this.props.fetchClientByNumber(this.props.user.client_number)
		.then(client => {
			if (!client || !client.activation_code)
			{
				this.setState({ error: true, loading: false })
				return ;
			}
			//cible /inscription/<code> : parcours invité complet (invite_client), pas de code à saisir
			const link = this._getBaseUrl() + '/inscription/' + client.activation_code
			QRCode.toDataURL(link, {
				errorCorrectionLevel: 'H',
				margin: 1,
				width: 480,
				color: {
					dark: '#1F2937',
					light: '#FFFFFF'
				}
			})
			.then(qr => {
				this.setState({ link: link, qr: qr, loading: false })
			})
			.catch(err => {
				console.log(err)
				this.setState({ link: link, qr: null, loading: false })
			})
		})
		.catch(err => {
			console.log(err)
			this.setState({ error: true, loading: false })
		})
	}

	_flashCopied = () => {
		this.setState({ copied: true })
		if (this.copyTimer !== null)
			clearTimeout(this.copyTimer)
		this.copyTimer = setTimeout(() => {
			this.setState({ copied: false })
		}, 2000)
	}

	_fallbackCopy = (link) => {
		const area = document.createElement('textarea')
		area.value = link
		area.setAttribute('readonly', '')
		area.style.position = 'absolute'
		area.style.left = '-9999px'
		document.body.appendChild(area)
		area.select()
		document.execCommand('copy')
		document.body.removeChild(area)
		this._flashCopied()
	}

	handleCopy = () => {
		if (this.state.link === null)
			return ;
		const link = this.state.link
		if (navigator.clipboard && navigator.clipboard.writeText)
		{
			navigator.clipboard.writeText(link)
			.then(() => this._flashCopied())
			.catch(() => this._fallbackCopy(link))
		}
		else
			this._fallbackCopy(link)
	}

	handleShare = () => {
		if (this.state.link === null || !navigator.share)
			return ;
		navigator.share({
			title: this.props.app_name,
			url: this.state.link
		})
		.catch(() => {})
	}

	render() {
		const lang_assets = this.props.lang_assets
		const color1 = '#' + this.props.theme.color1
		const can_share = (navigator.share !== undefined)
		let contentJSX = null
		if (this.state.error === true)
		{
			contentJSX = (
				<div className="rounded-md bg-red-50 p-4 mt-4 text-sm text-red-800">
					{lang_assets.error}
				</div>
			)
		}
		else
		{
			let qrJSX = null
			if (this.state.qr !== null)
			{
				let logoJSX = null
				if (this.props.logo)
				{
					logoJSX = (
						<span className="absolute top-1/2 left-1/2 h-11 w-11 rounded-full bg-white border-2 border-white shadow overflow-hidden" style={{ transform: 'translate(-50%, -50%)' }}>
							<img className="h-full w-full object-cover" src={this.props.logo} alt="" />
						</span>
					)
				}
				qrJSX = (
					<span className="relative inline-block p-2 bg-white border border-gray-200 rounded-2xl">
						<img className="h-40 w-40 block" src={this.state.qr} alt={lang_assets.qr_alt} />
						{logoJSX}
					</span>
				)
			}
			else
				qrJSX = (<span className="inline-block h-44 w-44 bg-gray-100 rounded-2xl animate-pulse"></span>)
			let link_name = (this.state.link !== null) ? this.state.link.replace(/^https?:\/\//, '') : "..."
			let copyIconJSX = null
			if (this.state.copied === true)
				copyIconJSX = (<CheckIcon className="h-5 w-5 text-green-600 flex-shrink-0" aria-hidden="true" />)
			else
				copyIconJSX = (<DuplicateIcon className="h-5 w-5 text-gray-500 flex-shrink-0" aria-hidden="true" />)
			let mainBtnJSX = null
			if (can_share === true)
			{
				mainBtnJSX = (
					<button type="button" onClick={this.handleShare} style={{ backgroundImage: 'none', backgroundColor: color1 }} className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-xl text-white text-base font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer">
						<ShareIcon className="h-5 w-5" aria-hidden="true" />
						{lang_assets.share_button}
					</button>
				)
			}
			else
			{
				mainBtnJSX = (
					<button type="button" onClick={this.handleCopy} style={{ backgroundImage: 'none', backgroundColor: color1 }} className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-xl text-white text-base font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer">
						<DuplicateIcon className="h-5 w-5" aria-hidden="true" />
						{(this.state.copied === true) ? lang_assets.copied : lang_assets.copy}
					</button>
				)
			}
			contentJSX = (
				<div>
					<p className="text-sm text-gray-500 mt-1">{lang_assets.subtitle}</p>
					<div className="text-center pt-4">
						{qrJSX}
						<p className="text-xs text-gray-500 pt-2 pb-4">{lang_assets.caption}</p>
					</div>
					<button type="button" onClick={this.handleCopy} aria-label={lang_assets.copy} style={{ backgroundImage: 'none', backgroundColor: '#F9FAFB' }} className="w-full flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-3 mb-3 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer">
						<span className="flex-1 text-left text-xs text-gray-700 font-mono truncate">{(this.state.copied === true) ? lang_assets.copied : link_name}</span>
						{copyIconJSX}
					</button>
					{mainBtnJSX}
				</div>
			)
		}
		return (
			<Transition show={this.props.open} as={Fragment}>
				<Dialog as="div" className="fixed inset-0 z-40" onClose={this.props.onClose}>
					<Transition.Child
						as={Fragment}
						enter="transition-opacity ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="transition-opacity ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
					</Transition.Child>
					<Transition.Child
						as={Fragment}
						enter="transform transition ease-out duration-300"
						enterFrom="translate-y-full"
						enterTo="translate-y-0"
						leave="transform transition ease-in duration-200"
						leaveFrom="translate-y-0"
						leaveTo="translate-y-full"
					>
						<div className="fixed inset-x-0 bottom-0 z-50 bg-white rounded-t-3xl px-5 pt-3 pb-8">
							<div className="mx-auto w-10 h-1 rounded-full bg-gray-300 mb-3"></div>
							<div className="flex items-center justify-between">
								<Dialog.Title className="text-lg font-bold text-gray-900">{lang_assets.title}</Dialog.Title>
								<button type="button" onClick={this.props.onClose} aria-label={lang_assets.close} style={{ backgroundImage: 'none', backgroundColor: '#F3F4F6' }} className="flex items-center justify-center h-8 w-8 rounded-full focus:outline-none focus:ring-2 focus:ring-gray-400 cursor-pointer">
									<XIcon className="h-4 w-4 text-gray-600" aria-hidden="true" />
								</button>
							</div>
							{contentJSX}
						</div>
					</Transition.Child>
				</Dialog>
			</Transition>
		)
	}
}

export default ShareApp
